WiseMetering.Collection.TariffTypes = WiseMetering.Collection.extend({
    model: WiseMetering.Model.TariffType
});
